module.exports = __webpack_public_path__ + "static/media/brand-refresh-tiktok-icon.2b35e3f7.svg";